import { action } from '@reatom/framework'

import { Array, BigNumber, Order, pipe, Result } from '@blade/std-lib'
import { Network } from '@root/entities/network/model'
import { dependenciesAtom } from '@root/features/shared/dependencies'
import { ApiError, apiRequest } from '@root/shared/api'

import { User } from '../model'

import type { UserSettingsPartialUpdatePayload } from '@blade/trade-api-client'
import type { DelugeId } from '@root/entities/user-short/model'
import type { Period } from '@root/shared/lib/period'

export const updateUserSettingsRequestAction = action(
  async (ctx, req: UserSettingsPartialUpdatePayload) => {
    const {
      tradeApiClient,
      environment: { assets },
    } = ctx.get(dependenciesAtom)

    const result = (
      await ctx.schedule(() =>
        apiRequest(ctx, tradeApiClient.user.userSettingsPartialUpdate, [req]),
      )
    ).pipe(Result.map((it) => User.fromDto(it, assets.avatarsHost)))

    return result
  },
  'updateUserSettingsRequestAction',
)

export const fetchUserPnlChartDataRequestAction = action(
  async (
    ctx,
    {
      network,
      period,
      delugeId,
    }: {
      network: Network.Network
      period: Period.Period
      delugeId?: DelugeId
    },
  ) => {
    const { tradeApiClient } = ctx.get(dependenciesAtom)

    const result = await ctx.schedule(() =>
      apiRequest(ctx, tradeApiClient.user.userPnlList, [
        {
          network: Network.toDto(network),
          period,
          delugeId: delugeId,
        },
      ]),
    )

    const mappedResult = pipe(
      result,
      Result.map((it) =>
        pipe(
          it,
          Array.map((it) => ({
            timestamp: new Date(it.timestamp),
            pnl: BigNumber.makeUnsafe(it.pnl),
            pnlNative: BigNumber.makeUnsafe(it.pnlNative),
            pnlUsd: BigNumber.makeUnsafe(it.pnlUsd),
          })),
          Array.sortWith((it) => it.timestamp, Order.Date),
        ),
      ),
      Result.mapError(ApiError.fallbackToUnknown),
    )

    return mappedResult
  },
  'fetchUserPnlChartDataRequestAction',
)
